export const TIMEZONES_MAP = {
    "America/New_York": "Eastern Time (New York)",
    "America/Chicago": "Central Time (Chicago)",
    "America/Denver": "Mountain Time (Denver)",
    "America/Phoenix": "Mountain Time (Phoenix)",
    "America/Los_Angeles": "Pacific Time (Los Angeles)",
    "Australia/Sydney": "Australian Eastern Daylight Time",
    "Australia/Brisbane": "Australian Eastern Standard Time",
};

export const TIMEZONES = Object.keys(TIMEZONES_MAP);

const FORM_INITIAL_TIMEZONE = "America/New_York";

export const ADDRESS_INITIAL_VALUES = {
    neighborhood: "",
    address: "",
    isBillable: false,
};

export const formInitialValues = {
    name: "",
    websiteUrl: "",
    email: "",
    additionalEmails: [],
    timezone: FORM_INITIAL_TIMEZONE,
    address: { ...ADDRESS_INITIAL_VALUES },
    additionalAddresses: [],
    isRetailerOnlineOnly: false,
};

export const SETTINGS_GENERAL_FORM_INITIAL_VALUES = {
    name: "",
    websiteUrl: "",
    email: "",
    additionalEmails: [],
    address: { ...ADDRESS_INITIAL_VALUES },
    additionalAddresses: [],
    isRetailerOnlineOnly: false,
};

export const SETTINGS_LOCATIONS_FORM_INITIAL_VALUES = {
    email: "",
    additionalEmails: [],
    phoneNumber: "",
    phoneNumbers: [],
    selectedCalendars: "",
};

export const WEB_APP_URL = "https://app.bookwithtote.com/";

export const TABS = {
    GENERAL: {
        title: "General",
        eventKey: "general",
    },
    GETTING_STARTED: {
        title: "Button",
        eventKey: "customization",
    },
    BOOKING_TOOLS: {
        title: "Booking Tools",
        eventKey: "bookingTools",
    },
    LOCATIONS: {
        title: "Locations",
        eventKey: "locations",
    },
    SUBSCRIPTION: {
        title: "Subscription",
        eventKey: "subscription",
    },
    QUEUES: {
        title: "Queues",
        eventKey: "queues",
    },
    USERS_PROFILES: {
        title: "Employees",
        eventKey: "usersProfiles",
        tabs: {
            USERS_SCHEDULE: {
                title: "Schedules",
                eventKey: "usersSchedules",
            },
            USERS_QUESTIONNAIRE: {
                title: "Questionnaires",
                eventKey: "usersQuestionnaires",
            },
            USERS_WEBAPP_SETTINGS: {
                title: "Webapp Settings",
                eventKey: "usersWebappSettings",
            },
        },
    },
};

export const DEFAULT_ACTIVE_TAB_KEY = TABS.GENERAL.eventKey;

export const defaultLocation = { value: 0, title: "Virtual" };
